document.addEventListener('DOMContentLoaded', async () => {
    const CATEGORY = document.querySelector('#generated-category');
    if (!CATEGORY) return;

    // === helpers (твої) ===
    function escapeHtml(str = '') {
        return String(str).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
    }

    function renderFeature(iconSrc, text, allowTwoLines = false) {
        // очікуємо, що text вже escape'нутий; нижче лише вставляємо <br />
        const labelHtml = allowTwoLines ? text.replace(/\sяк\sінгредієнт\s№1/i, ' як <br />інгредієнт №1') : text;

        return `
        <div class="flex md:flex-col flex-row gap-2.5 md:items-start items-center">
          <div class="flex flex-col gap-2.5 items-start">
            <img loading="lazy" class="w-8 aspect-square" src="${iconSrc}" alt="Icon" />
            <div class="w-10 h-[1px] bg-white"></div>
          </div>
          <p>${labelHtml}</p>
        </div>`;
    }

    // === load data ===
    let categories = [];
    try {
        const res = await fetch('/data/products-data.json', { cache: 'no-cache' });
        categories = await res.json();
        if (!Array.isArray(categories)) throw new Error('JSON must be an array');
    } catch (e) {
        console.error('Failed to load /data/products-data.json', e);
        return;
    }

    // === render ===
    const frag = document.createDocumentFragment();

    categories.forEach((s, i) => {
        const { title = '', desc = '', mainImg = '', zoomImg = '', ctaHref = '#', features = [] } = s || {};
        const [f1 = '', f2 = '', f3 = ''] = features;
        const uid = `zoomModal-${i}`;

        const safeTitle = escapeHtml(title);
        const safeDesc = escapeHtml(desc);
        const safeF1 = escapeHtml(f1);
        const safeF2 = escapeHtml(f2);
        const safeF3 = escapeHtml(f3);

        const section = document.createElement('section');
        section.className = 'relative max-1440 md:py-[200px] py-20 flex md:flex-row flex-col md:items-center w-full md:px-0 px-4 text-white';

        section.innerHTML = `
        <div class="md:w-1/2 w-full relative">
          <img class="mx-auto" src="${mainImg}" alt="${safeTitle}" loading="lazy" />
          <button class="btn-zoom absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 w-[66px]"
                  data-target="${uid}" data-zoom="${zoomImg}"
                  aria-label="Zoom image: ${safeTitle}">
            <img class="w-[50px] aspect-square" src="/img/circle-search.svg" alt="Icon" />
            <p class="text-xs">Детальніше</p>
          </button>
        </div>
  
        <div class="md:w-1/2 w-full flex flex-col gap-11">
          <h3 class="md:text-4xl text-3xl font-playfair uppercase md:mt-0 mt-10">${safeTitle}</h3>
          <p class="font-helvetica-light">${safeDesc}</p>
  
          <div class="flex md:flex-row flex-col md:gap-0 gap-5 justify-between text-sm">
            ${renderFeature('/img/ico-1.svg', safeF1)}
            ${renderFeature('/img/ico-2.svg', safeF2, true)}   <!-- тут дозволяємо перенос -->
            ${renderFeature('/img/ico-3.svg', safeF3)}
          </div>
  
          <a class="w-[230px] h-[45px] flex items-center justify-center text-black bg-white border-white border-[1px] hover:bg-c-black hover:text-white"
             href="${ctaHref}">Переглянути більше</a>
        </div>
  
        <!-- індивідуальний модал для цього блоку -->
        <div id="${uid}" class="fixed inset-0 z-[100] hidden items-center justify-center" data-zoom-modal>
          <div class="absolute inset-0 bg-black/70" data-zoom-backdrop></div>
          <div class="relative max-w-[90vw] max-h-[90vh]">
            <button class="absolute -top-10 right-0 text-white text-2xl" data-zoom-close aria-label="Закрити">✕</button>
            <img data-zoom-img src="" alt="Zoom" class="block max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-xl" />
          </div>
        </div>
        <div class="absolute bottom-0 left-0 w-full flex items-center">
            <div class="bg-white h-[1px] md:w-[94%] w-[90%] md:ml-[3%] ml-[3%]"></div>
            <div class="bg-white md:w-[0.5%] w-[2%] aspect-square rounded-full"></div>
        </div>
      `;

        frag.appendChild(section);
    });

    CATEGORY.appendChild(frag);

    // === zoom open (delegated) ===
    CATEGORY.addEventListener('click', (e) => {
        const btn = e.target.closest('.btn-zoom');
        if (!btn) return;
        const modalId = btn.dataset.target;
        const src = btn.dataset.zoom;
        const modal = document.getElementById(modalId);
        if (!modal || !src) return;

        modal.querySelector('[data-zoom-img]').src = src;
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.documentElement.style.overflow = 'hidden';
        const img = new Image();
        img.src = src; // preload
    });

    // === zoom close (backdrop/X) ===
    CATEGORY.addEventListener('click', (e) => {
        const isBackdrop = e.target.matches('[data-zoom-backdrop]');
        const isClose = e.target.closest('[data-zoom-close]');
        if (!isBackdrop && !isClose) return;

        const modal = e.target.closest('[data-zoom-modal]') || CATEGORY.querySelector('[data-zoom-modal].flex');
        if (!modal) return;

        modal.classList.add('hidden');
        modal.classList.remove('flex');
        modal.querySelector('[data-zoom-img]').src = '';
        document.documentElement.style.overflow = '';
    });

    // === Esc close ===
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const openModal = CATEGORY.querySelector('[data-zoom-modal].flex');
        if (!openModal) return;
        openModal.classList.add('hidden');
        openModal.classList.remove('flex');
        openModal.querySelector('[data-zoom-img]').src = '';
        document.documentElement.style.overflow = '';
    });
});
